import axios from "axios";
import { Base_URL } from "../url";

/**
 * Get Dropdown Data
 */
export const getExcelObjects = async () => {
  const res = await axios.get(
    `${Base_URL}/ExcelUploadMaster/GetExcelObjects`
  );
  return res.data;
};

/**
 * Upload Excel File
 */
export const uploadExcelFile = async (
  file,
  guid,
  organisationId,
  userId
) => {
  const formData = new FormData();

  // 🔥 MUST MATCH BACKEND PROPERTY NAMES EXACTLY
  formData.append("File", file);
  formData.append("ExcelUploadGuid", guid);
  formData.append("OrganisationId", organisationId);
  formData.append("UserId", userId);

  const res = await axios.post(
    `${Base_URL}/ExcelUploadMaster/UploadMasterExcelData`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );

  return res.data;
};

/**
 * Download Template
 */
